<template>
  <base-message :message="message">
    <div class="file-message">
      <label><b class="is-text-rsmall is-text-info">文件</b></label>
      <div class="file"><b>{{ message.data.filename }}</b></div>
      <br>
      <a @click="checkFile()"
         class="button is-link is-small">下载文件</a>
      <div v-show="askFileOption">
        <p>检测到文件名相同的文件</p>
      </div>
      <div class="buttons one-line" v-if="askFileOption">
        <a @click="createFile(false)"
           class="button is-link is-small">覆盖原文件</a>
        <a @click="openFile()"
           class="button is-link is-small">打开文件</a>
      </div>
    </div>
  </base-message>
</template>

<script>
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import path from 'path'

export default {
  props: ['message'],
  components: { BaseMessage },
  data () {
    return {
      IClassroom: IClassroom,
      btnLoading: false,
      filePath: '',
      askFileOption: false
    }
  },
  methods: {
    async checkFile () {
      if (this.askFileOption) {
        this.askFileOption = false
        return
      }
      this.btnLoading = true
      const course = this.IClassroom.course
      const haveFile = await IClassroom.isFileExist(path.join(course.courseName, course.groupName, course.chapterId, this.message.data.filename))
      if (!haveFile) {
        await this.createFile(true)
      } else {
        this.askFileOption = true
      }

      await IClassroom.requestNextMessage(1000)
    },
    async createFile () {
      this.askFileOption = false
      const course = this.IClassroom.course
      const fileData = await IClassroom.callRemote('course.get_file', {
        courseId: course.courseId,
        groupId: course.groupId,
        chapterId: course.chapterId,
        filename: this.message.data.filename
      })
      this.filePath = await IClassroom.createWorkspaceFile(path.join(course.courseName, course.groupName, course.chapterId, this.message.data.filename).join(course.courseName, course.groupName, course.chapterId, this.message.data.filename), fileData, false)
      this.btnLoading = false
    },
    async openFile () {
      await IClassroom.openWorkspaceFile(this.message.data.filename)
    }
  }
}
</script>

<style lang="stylus" scoped>
.file-message {
  padding .75em
  min-width 200px
}

.buttons {
  margin 1rem 0 .5rem 0

  .button {
    padding .4em .75em
    line-height 1
  }
}
</style>
